var _rect, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_131",
    "data-name": "Group 131",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 56,
    height: 56,
    fill: "#090707",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(6.318 12.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M334.481,345.546a1.844,1.844,0,0,0,1.99,1.207q17.739-.027,35.477-.012h.608c-.178.191-.283.312-.4.424q-5.229,5.219-10.461,10.434a1.652,1.652,0,0,0-.548,1.787,1.513,1.513,0,0,0,2.339.762,3.758,3.758,0,0,0,.438-.4q6.616-6.615,13.231-13.232a1.6,1.6,0,0,0,0-2.623q-6.645-6.646-13.288-13.294a1.613,1.613,0,0,0-1.783-.539,1.526,1.526,0,0,0-.687,2.395,4.753,4.753,0,0,0,.374.4q5.178,5.18,10.36,10.355a2.6,2.6,0,0,0,.423.284l-.1.171h-.521q-17.76,0-35.519.01a2.42,2.42,0,0,0-1.208.255c-.317.192-.5.613-.734.934Z",
    transform: "translate(-334.481 -329.969)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.46f7751b78e540417c8169777c47a540.svg";
export { ForwardRef as ReactComponent };